<template>
  <section class="shadow-box modal_wrapper" v-show="showNotificationModal">
    <div class="popup-message">
      <div class="main-part">
        <div class="general-body">
          <h3 class="title">{{ t(title) }}</h3>
          <p class="message">{{ t(content) }}</p>
          <div class="desktop-buttons">
            <button
              class="btn desktop"
              @click="setShowNotificationModal(false)"
            >
              {{ t("ok_label") }}
            </button>
          </div>
        </div>
      </div>
      <div class="mobile-buttons">
        <button class="btn mobile" @click="setShowNotificationModal(false)">
          {{ t("ok_label") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "NotificationModal",
  props: ["title", "content"],
  computed: {
    ...mapState(["showNotificationModal"]),
    ...mapGetters(["t"])
  },
  methods: {
    ...mapMutations(["setShowNotificationModal"])
  }
};
</script>

<style lang="scss" scoped>
.modal_wrapper.shadow-box {
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  z-index: 10000000000000000;
  .popup-message {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 90%;
    transform: translate(-50%, -50%);
    max-width: 500px;
    height: auto;
    z-index: 9;
    text-align: center;
    padding: 32px 40px;
    border-radius: 5px;
    background-color: #fff;
    color: #424242;
    .main-part {
      .general-body {
        padding-bottom: 0;
        .title {
          font-size: 24px;
          margin-bottom: 22px;
          margin-right: auto;
          margin-left: auto;
          color: #424242;
        }
        .message {
          font-size: 16px;
          color: #333333;
          margin-bottom: 30px;
        }
      }
    }
    .mobile-buttons {
      display: none;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border-radius: 3px;
      //padding: 7px;
      outline: none;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      background: #1c79be;
      margin: 0 auto;
      width: 330px;
      height: 40px;
      font-weight: 500;
      &:hover {
        color: #fff; /*required to ignore general css at stage*/
      }
    }
    @media only screen and (max-width: 768px) {
      margin: 0;
      padding: 0;
      max-width: calc(100% - 3rem);
      .main-part {
        padding: 2rem 1.125rem;
        border-radius: 0px;
        margin: 0 auto;
        .general-body {
          .title {
            margin-bottom: 1rem;
          }
          .message {
            margin-bottom: 0;
          }
        }
      }
      .mobile-buttons {
        display: flex;
        width: 100%;
        .btn {
          border-radius: 0;
          padding: 0;
          width: 100%;
        }
      }
      .desktop-buttons {
        display: none;
      }
    }
  }
}
</style>
